module.exports = __webpack_public_path__ + "img/04-md.2b00b55.webp";